import { render, staticRenderFns } from "./EditSearchSynonyms.vue?vue&type=template&id=030c5887&scoped=true"
import script from "./EditSearchSynonyms.vue?vue&type=script&lang=js"
export * from "./EditSearchSynonyms.vue?vue&type=script&lang=js"
import style0 from "./EditSearchSynonyms.vue?vue&type=style&index=0&id=030c5887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c5887",
  null
  
)

export default component.exports